module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/sunlight.334aa4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/sunlight.jpg
// module id = 4qs8
// module chunks = 0